import React, { Component } from 'react'
import { FormattedMessage, FormattedDate } from 'react-intl'
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import GlobalHelper from "../../../../common/GlobalHelper.jsx"
import Icon from "../../../../common/icon/icon.component.jsx"
import EditButtonSectionModal from "../../editbutton.component.jsx";
import AddressComponent from "../../../../customer/components/AddressComponent"

class DocumentInfoContentWord extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            isPdf: this.props.isPdf || false,
            isDummy: this.props.isDummy || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function () { },
            pdfLoading: false,
            id: this.props.id || '',
        }
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            variables: nextProps.variables || null,
            section: nextProps.section || null,
            isPdf: nextProps.isPdf || false,
            isDummy: nextProps.isDummy || false,
            id: nextProps.id || '',
        })
    }


    render() {
        if (!this.state.variables) {
            return <div />
        }


        let parentOrganizationName = ""
        if (this.state.variables.customerParentOrganization.name && this.state.section.attributes.content.showParentOrganization) {
            parentOrganizationName = <p className="m-0">
                {this.state.variables.customerParentOrganization.name}
            </p>
        }

        return <div className={"row "} id={this.state.id}>
            <table style={{
                width: '100%',
                fontFamily: this.state.variables.global.font + ', sans-serif',
                fontSize: '12px',
            }}>
                <tr>
                    <td style={{ textAlign: 'center' }} colSpan={2}>
                        {this.state.variables.company.logoUrl ? <img src={this.state.variables.company.logoUrl} /> : <h2>
                            {this.state.variables.company.name}
                        </h2>}
                        <br />
                        <br />
                    </td>
                </tr>
                <tr>
                    <td style={{ padding: '0', verticalAlign: 'top' }}>
                        <p style={{ margin: '0' }}>
                            <strong>
                                <FormattedMessage
                                    id="templates.header.from_label"
                                    defaultMessage="From"
                                /> :</strong>
                        </p>
                        <p style={{ margin: '0' }}>
                            {this.state.variables.seller.name}
                        </p>
                        <AddressComponent
                            lineStyle={{ margin: '0' }}
                            value={this.state.variables.company.address}
                        />
                        <p style={{ margin: '0' }}>
                            <a href={'mailto:' + this.state.variables.seller.email}>{this.state.variables.seller.email}</a>
                        </p>
                        <p style={{ margin: '0' }}>
                            <a href={'tel:' + this.state.variables.company.phoneNumber}>
                                {GlobalHelper.formatPhoneNumber(this.state.variables.company.phoneNumber, this.state.variables.company.address.countryCode)}
                            </a>
                        </p>
                    </td>
                    <td style={{ padding: '0', verticalAlign: 'top' }}>
                        <p style={{ margin: '0' }}>
                            <strong>
                                <FormattedMessage
                                    id="templates.header.to_label"
                                    defaultMessage="To"
                                /> :</strong>
                        </p>
                        <p style={{ margin: '0' }}>
                            {this.state.variables.customer.name}
                        </p>
                        {parentOrganizationName}
                        <AddressComponent
                            lineStyle={{ margin: '0' }}
                            value={this.state.variables.customer.address}
                        />
                        <p style={{ margin: '0' }}>{this.state.variables.customer.email}</p>
                        <p style={{ margin: '0' }}>{GlobalHelper.formatPhoneNumber(this.state.variables.customer.phoneNumber, this.state.variables.customer.address.countryCode)}</p>
                    </td>
                    {this.state.section.attributes.content.showShippingContact ? <td style={{ padding: '0', verticalAlign: 'top' }}>
                        <div className={"mb-1"}>
                            <p style={{ margin: '0' }}>
                                <strong>
                                    <FormattedMessage
                                        id="templates.header.ship_to_label"
                                        defaultMessage="Ship To"
                                    /> :</strong>
                            </p>
                            <p style={{ margin: '0' }}>
                                {this.state.variables.shipTo.name}
                            </p>
                            <p style={{ margin: '0' }}>
                                <AddressComponent
                                    lineStyle={{ margin: '0' }}
                                    value={this.state.variables.shipTo.address}
                                />
                            </p>
                        </div>
                    </td> : ''}
                </tr>
                <tr>
                    <td>
                        <br />
                    </td>
                </tr>
                <tr>
                    <td style={{ padding: '0', verticalAlign: 'top' }}>
                        <p style={{ margin: '0' }}>
                            <strong>
                                <FormattedMessage
                                    id="proposal.items.quote_reference"
                                    defaultMessage="Reference"
                                />
                                :</strong> {this.state.variables.document.reference}<br />
                            <strong>
                                <FormattedMessage
                                    id="proposal.items.quote_date"
                                    defaultMessage="Date"
                                />
                                :&nbsp;
                            </strong>
                            <FormattedDate
                                year='numeric'
                                month='long'
                                day='numeric'
                                value={
                                    this.state.variables.document.date ?
                                        new Date(this.state.variables.document.date) :
                                        new Date()
                                } />
                            <br />
                        </p>
                    </td>
                </tr>

            </table>
        </div>
    }

}

export default DocumentInfoContentWord





// WEBPACK FOOTER //
// ./src/template/sections/content/document-info/word.component.jsx